import angular from 'angular';

module.exports = angular.module('common.filters.implied-price-per-sqft', [
  require('./implied-price-cents')
])
.filter('impliedPricePerSqFt', function(impliedPriceCentsFilter) {
  return function(comp, lead) {
    return impliedPriceCentsFilter(comp) / lead.dwellings_detail.sq_ft;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/implied-price-per-sqft.js
 **/